import { render, staticRenderFns } from "./footers-tab.vue?vue&type=template&id=0c31a481"
import script from "./footers-tab.vue?vue&type=script&lang=js"
export * from "./footers-tab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports